import { HttpClient } from "@angular/common/http";
import { IResult } from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ICreateMaterialChain } from "./interfaces/create-distribution-chain.interface";
import { IUpdateMaterialChain } from "./interfaces/update-distribution-chain.interface";
import MaterialDistributionChainAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material/material-distribution-chain/material-distribution-chain.entity";
import { environment as env } from "../../../../../environments/environment.prod";
const apiUrl = env.API_MATERIAL_URL;
const moduleName = "material_distribution_chain";

@Injectable({
  providedIn: "root",
})
export class MaterialDistributionService extends AbstractService<
MaterialDistributionChainAttributes,
ICreateMaterialChain,
IUpdateMaterialChain
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByMaterialId(materialId: string): Observable<IResult<MaterialDistributionChainAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${materialId}`;
    return this.http.get<IResult<MaterialDistributionChainAttributes>>(API_URL);
  }
}